<template>
<div class="chapter">
<div class="inner_page">
<section epub:type="chapter">
<header>
<h1 class="topictitle1" id="ch8"><a href="#/nav#nch8"><span class="section_number">CHAPTER 3</span><br/><span class="title">THE SORCERESS QUEEN OF MOUND CAJORIA</span></a></h1>
</header>
<p>The foraging ants, pincers full, continued their climb up the mound with the essential task of delivering their leaves. After
            skirting the midden, they passed through 127 levels where different castes worked at specific labors. The first rings were
            the colorless slums of the laboring humans, an expanse of one-room shelters made of sand grains glued together by ant dung
            and perched atop stilts. Nearer to the mound, the leaf-cutters crawled through the rings of craftsmen and traders. These castes
            were privileged to live in two-room hovels of sand bound by sulfurous tar.
         </p>
<p>At a higher elevation were the treasure-stuffed homes of the merchants, constructed from white sand fused with fragrant resins.
            At the next level were the black sand barracks of the soldiers and above these were their generals’ austere mansions. On top
            of these, and in marked contrast, were the priests’ ornate rectories. These were fashioned from grains of pinkish sand and
            embedded with images of the Slopeish gods.
         </p>
<p>Finally the foragers reached the crystal palaces of the royal family. As the ants marched over these magnificent structures,
            their leaves were reflected in a golden lacquer. The palaces encircled the mound’s opening, which was guarded by four ants
            with giant heads that locked and unlocked as a living gate.
         </p>
<p>Once inside the mound, the foragers descended to deliver their leaves to the dark, deep chambers of the chewing ants. This
            caste would make a rough carpet by shearing the leaves into tiny pieces. Smaller ants, the fungus growers, would chew these
            pieces into a fine paste, fertilize it with liquid manure, and then infuse it with threads of fungus. The threads would stalk
            and fruit into the sacred mushrooms, the staple food of both the ants and the human parasites that lived among them.
         </p>
<p>Once they made their delivery, the foragers exited for a second trip and more leaves. They spiraled past a stately train of
            silk-draped riding ants with noisy bangles clasped above their claws. Atop the lead ant was Queen Polexima, the most important
            human in all Cajoria. She and her entourage were just returning from the essential ritual she practiced as the mound’s sorceress.
         </p>
<p>In the ninth month of her ninth pregnancy, riding had become difficult for the queen. Two things were on her mind as she entered
            the tunnel that led to her palace: lunch and a comfortable seat. Once in her chambers, she sat down to savor a sun-baked swamp
            fly as her servant informed her of the flea attack.
         </p>
<p>“Good gods,” she said. “Did anyone die?”</p>
<p>“Eight hunters . . . all of them boys,” said Mulga, a woman from the servant caste with freckles as numerous as stars.</p>
<p>“Children? How horrible.” Polexima pushed her food away, having lost her appetite. She tried to hide her moistening eyes.</p>
<p>“Majesty,” said Mulga, somewhat shyly. “Your hair could use a bit of brushing.”</p>
<p>“Oh, thank you. Bring me my toiletries, please.”</p>
<p>In a hand mirror fashioned from the wing of a water beetle, Polexima saw her yellow-white hair was now streaked with silver.
            Her pale skin with its golden undertones had grown more wrinkled about her eyes and mouth. After thirty-nine summers, she
            saw she was somewhere between being a fabled beauty and a faded one. “What did you expect?” she muttered to herself. “That
            it wouldn’t happen to <i>you</i>?” Suddenly, the queen dropped the mirror and clutched her belly.
         </p>
<p>“Mulga . . .” she gasped.</p>
<p>The queen’s tone frightened the servant as well as the twenty others in the chamber. They were as still as stone as they stared
            at their queen.
         </p>
<p>“Yes, Majesty?”</p>
<p>“It’s time.”</p>
<p>The servant continued to stare.</p>
<p>“Mulga, will you run and summon the priests, please?”</p>
<p>“Yes, Majesty. Apologies.”</p>
<p>As her cushion soaked with fluid, Polexima’s mind flooded with painful concerns. After eight deliveries, it never really got
            any easier. Panic was throbbing inside her but she knew giving into it would accomplish nothing. She drew deep breaths as
            she rubbed the belly of the Grasshopper idol in her bedside altar and chanted all his names in prayer.
         </p>
<p class="txtb2"> </p>
<p>Mulga scurried through the vast chamber and its furnishings of carved amber. To reach the outside pathways, she had to crawl
            through a short tunnel, then push through a portal whose flaps kept the ants out.
         </p>
<p>Standing under the shade of the mound’s rain shield, the servant tied on her band of antennae before entering the dense traffic
            of ants and humans. She was trembling when she stopped before a gathering of others from her caste. They were picking up the
            day’s drinking water at the royal dew station where a man wearing a bucket-shaped hat stood on a sand-sled and used a broad
            knife to slice water from a barrel.
         </p>
<p>“What’s wrong with you?” asked Mulga’s sister, who served the crown princess.</p>
<p>“The queen—her water’s broken.”</p>
<p>Everyone gasped. The dew collector dropped his knife. Some fell to their knees and others fainted. All of them turned to their
            gods in prayer.
         </p>
<p>Mulga knew they should have been praying for the queen’s health and blessings for the new heir. Instead, like her, they were
            muttering prayers that she give birth to a male.
         </p>
<p>Or at least a female whose life would be brief.</p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Chapter_3.vue?8262d0cc